import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ConsumerTypesActions } from './consumer-types.actions';
import { ConsumerTypesSelectors } from './consumer-types.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {ConsumerType} from '@emm/core/models/consumer-type.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {SearchFilter} from '@emm/core/models/search-filter';


export interface ManagementConsumerTypesQueries extends AsyncActionQueries {
    all$: Observable<ConsumerType[]>;
    selected$: Observable<ConsumerType>;
}

@Injectable({
    providedIn: 'root'
})
export class ManagementConsumerTypesStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>) {
        super(store, ConsumerTypesSelectors);
    }



    dispatch = {
        selectConsumerType: (tag: string) =>
            this.store.dispatch(ConsumerTypesActions.select({ tag })),
        searchConsumerTypes: (filter: SearchFilter) =>
            this.store.dispatch(ConsumerTypesActions.search({ filter })),
        openAddConsumerTypeDialog: () =>
            this.store.dispatch(ConsumerTypesActions.openAddDialog()),
    };



    queries: ManagementConsumerTypesQueries = {
        all$: this.selectNonNil(ConsumerTypesSelectors.getFilteredItems),
        selected$: this.selectNonNil(ConsumerTypesSelectors.getSelected),
        ...this.asyncActionQueries,
    };



}
